import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ProductOrchestratorService } from '../+products/product-orchestrator.service';
import { SNAPService } from '../+products/snap/snap.service';
import { AppInsightsService } from '../app-insights/appinsights.service';
import { InterviewProductDataProviderService } from './abstract-interview-product-data-provider.service';




@Injectable()
export class InterviewSNAPDataProviderService extends InterviewProductDataProviderService {

    constructor(store: Store,
        snapService: SNAPService,
        productOrchestratorService: ProductOrchestratorService,
        appInsightsService: AppInsightsService
    ) {
        super(store, snapService, productOrchestratorService, appInsightsService);
    }

}
